import { IAppState } from 'config/redux/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { setUserAddressIdCookie } from 'utils/getSelectedAddress.util';

import history from 'routes/customHistory';
import { EUrlParams, NEW_CHECKOUT_PAGE } from 'config/Urls.config';
import { hideNotification } from 'common/Notification/redux/notification.action';
import useCartShipments from 'hooks/useCartShipments.hook';
import { resetSubstitutes } from 'pages/NewCart/redux/actions/substitutes.action';

// only for new cart
const useGoToCheckoutScreen = () => {
  const store = useSelector((state: IAppState) => state);
  const dispatch = useDispatch();
  const userData: {
    totalPoints: string;
    cardNumber: string;
    selectedAddress: any;
    addresses: any;
    countryConfig: any;
    town: string;
  } = store.userData;

  const { createExpressCart } = useCartShipments(false);

  const goToCheckoutScreen = (params: {
    shipmentType?: string;
    shopId?: string;
    isNewJourney?: boolean;
    isExpressSpc?: boolean;
  }) => {
    const {
      shipmentType = 'DEFAULT',
      // shopId = '',
      isNewJourney = false,
      isExpressSpc = false,
    } = params;
    dispatch(hideNotification());
    // Reset substitutes state so that if user goes back to cart page, substitutes state will not persisted
    dispatch(resetSubstitutes());
    setUserAddressIdCookie(userData);
    if (isNewJourney) {
      const checkoutType = shipmentType;
      history.push(`${NEW_CHECKOUT_PAGE}?checkoutType=${checkoutType}`);
      return;
    }

    if (isExpressSpc) {
      createExpressCart(() => history.push(`${NEW_CHECKOUT_PAGE}/${EUrlParams.EXPRESS}`));
      return;
    }

    history.push(NEW_CHECKOUT_PAGE);
    return;
  };

  return {
    goToCheckoutScreen,
  };
};

export default useGoToCheckoutScreen;
